export class Ringpool {
  #productos = [
    {
      producto: "Hogar",
      telefono: "900869267",
    },
    {
      producto: "Marca",
      telefono: "900869271",
    },
    {
      producto: "Coche",
      telefono: "900869272",
    },
    {
      producto: "Vida",
      telefono: "900869273",
    },
    {
      producto: "Vividoras",
      telefono: "900869274",
    },{
      producto: "Decesos",
      telefono: "900869275",
    },
    {
      producto: "Salud",
      telefono: "900869276",
    },
    {
      producto: "Accidentes",
      telefono: "900869278",
    },
    {
      producto: "Mascotas",
      telefono: "900869279",
    },
     {
      producto: "Acb",
      telefono: "900869281",
    },
     {
      producto: "Marcaacb",
      telefono: "900869281",
    }
  ];

  loadDefaultPhoneByProduct(producto_landing) {
    try {
      if (
        typeof producto_landing !== "string" &&
        typeof producto_landing !== "undefined"
      ) {
        throw new Error(
          "El producto debe ser una cadena de texto y no debe ser null"
        );
      }

      const telefonosFiltrados = this.#productos
        .filter(
          (item) =>
            item.producto.toLowerCase() === producto_landing.toLowerCase()
        )
        .map((item) => item.telefono);

      if (telefonosFiltrados.length === 0) {
        throw new Error(
          `No se encontraron teléfonos para el producto: "${producto_landing}".`
        );
      }
        globalThis.DFI_client = {
          ...globalThis.DFI_client,
          defaultPhoneUnailable: telefonosFiltrados[0]

        };
      return   globalThis.DFI_client;
      
    } catch (error) {
      throw new Error(`Error en loadDefaultPhoneByProduct: ${error.message}`);
    }
  }
  getDefaultPhone({ producto_landing }) {
    try {
      const telefonos = this.loadDefaultPhoneByProduct(producto_landing);
    } catch (error) {
      console.error("Se produjo un error:", error.message);
    }
  }
}
